import { Directive, Self, TemplateRef } from '@angular/core';
import { SidenavService } from './sidenav.service';

@Directive({
  selector: 'ng-template[ssMobileToolbarContent]',
  standalone: true,
})
export class MobileToolbarContentDirective {


  constructor(
    private readonly _sidenavService: SidenavService,
    @Self()
    private readonly _templateRef: TemplateRef<any>
  ) {

  }

  ngAfterViewInit() {

    this._sidenavService.mobileToolbarTemplateRefSubject.next(this._templateRef)
  }
}
